import script from "./j-text3.vue?vue&type=script&lang=ts&setup=true"
export * from "./j-text3.vue?vue&type=script&lang=ts&setup=true"

import "./j-text3.vue?vue&type=style&index=0&id=bf55028e&lang=less&scoped=true"

import exportComponent from "/root/djmesweb-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf55028e"]])

export default __exports__